import { render } from "./SettingTime.vue?vue&type=template&id=22ddb3ef&scoped=true"
import script from "./SettingTime.vue?vue&type=script&lang=js"
export * from "./SettingTime.vue?vue&type=script&lang=js"

import "./SettingTime.vue?vue&type=style&index=0&id=22ddb3ef&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ddb3ef"]])

export default __exports__